import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt'
import IconButton from '@material-ui/core/IconButton'
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt'
import YouTubeIcon from '@material-ui/icons/YouTube'
import CommentIcon from '@material-ui/icons/Comment'
import ChatBubbleIcon from '@material-ui/icons/ChatBubble'
import VisibilityIcon from '@material-ui/icons/Visibility'
import Tooltip from '@material-ui/core/Tooltip'
import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import FavoriteIcon from '@material-ui/icons/Favorite'
import { useStyles } from './styles'

const VideoCardList = (props) => {
  const {
    handleFeelingsById,
    handleCommetsByVideoId,
    handleDeleteVideoList,
    addToVideoItemList,
    video,
    isSearch,
  } = props
  const classes = useStyles()

  return (
    <article className={classes.horizontalList}>
      <>
        <div className={classes.containerImage}>
          <img
            src={video?.items[0]?.snippet?.thumbnails?.high?.url}
            alt={video?.items[0]?.snippet?.channelTitle}
          />
        </div>
        <div className={classes.cardBodyList}>
          <h4>
            <strong>Título</strong>
          </h4>
          <p>{video.items[0]?.snippet.title}</p>
          <h4>
            <strong>Canal</strong>
          </h4>
          <p>{video.items[0]?.snippet.channelTitle}</p>
          <h4>
            <strong>Descripción</strong>
          </h4>
          <span>{video.items[0]?.snippet.description.slice(0, 150)}</span>
          <h4>
            <strong>Fecha de Publicación</strong>
          </h4>
          <p>{video.items[0]?.snippet.publishedAt}</p>
          <h4>
            <strong>Estadísticas</strong>
          </h4>
          <div id="card Número">
            <Tooltip title="Likes">
              <IconButton>
                <ThumbUpAltIcon />
              </IconButton>
            </Tooltip>
            <span>{video.items[0]?.statistics?.likeCount}</span>
            <Tooltip title="DisLike">
              <IconButton>
                <ThumbDownAltIcon />
              </IconButton>
            </Tooltip>
            <span>{video.items[0]?.statistics?.dislikeCount}</span>
            <Tooltip title="ViewCount">
              <IconButton>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            <span>{video.items[0]?.statistics?.viewCount}</span>{' '}
            <Tooltip title="Comments">
              <IconButton>
                <ChatBubbleIcon />
              </IconButton>
            </Tooltip>
            <span>{video.items[0]?.statistics?.commentCount}</span>{' '}
          </div>
          <a
            target="blank"
            href={`https://www.youtube.com/watch?v=${video.videoId}`}
          >
            <Tooltip title="Youtube">
              <IconButton>
                <YouTubeIcon style={{ color: '#F70000' }} alt="Ver Video - " />
              </IconButton>
            </Tooltip>
          </a>
          {isSearch && (
            <>
              <IconButton onClick={() => addToVideoItemList(video)}>
                <LibraryAddIcon style={{ color: '#ab47bc' }} alt="Añadir " />
              </IconButton>
              <span>Añadir</span>
            </>
          )}
          {!isSearch && (
            <>
              <Tooltip title="Sentimientos">
                <IconButton
                  onClick={() =>
                    handleFeelingsById(
                      video.videoId,
                      video.items[0].snippet.title,
                    )
                  }
                >
                  <FavoriteIcon
                    style={{ color: '#4267B2' }}
                    alt="Sentimientos- "
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Comentarios">
                <IconButton
                  onClick={() =>
                    handleCommetsByVideoId(
                      video.videoId,
                      video.items[0].snippet.title,
                    )
                  }
                >
                  <CommentIcon
                    style={{ color: '#ffa500' }}
                    alt="Comentarios- "
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Eliminar">
                <IconButton
                  onClick={() => handleDeleteVideoList(video.videoId)}
                >
                  <DeleteIcon style={{ color: '#898F9C' }} alt="Eliminar - " />
                </IconButton>
              </Tooltip>
            </>
          )}
          <br />
        </div>
      </>
    </article>
  )
}

export default VideoCardList
